/**
 * Cos Tooltip Component
 * Base tooltip functionality for custom elements
 */

import { Listeners } from './utils.js';

class CosTooltip extends HTMLElement {
  connectedCallback() {
    this.listeners = new Listeners();
    this.settings = JSON.parse(this.dataset.settings || '{}');
      
    this.listeners.add(this, 'click', (e) => {
      e.stopPropagation();
      clearTimeout(this.closeTimeout);
      this.classList.add('tooltip--visible');
    });
    
    // remove class on click outside
    this.listeners.add(document, 'click', () => {
      this._resetTooltips();
      // if (this.settings.clickOnly) {
      // }
      // this.timeOutClose();
    });

    // on mouseover remove all other tooltips but this (only if not clickOnly)
    (!this.settings.clickOnly) && this.listeners.add(this, 'mouseover', () => {
      clearTimeout(this.closeTimeout);
      this._resetTooltips(this);
      !this.settings.noMouseover && this.classList.add('tooltip--visible');
    });

    // on mouseout close tooltip
    this.listeners.add(this, 'mouseout', () => {
      this.timeOutClose();
    });
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  timeOutClose() {
    clearTimeout(this.closeTimeout);
    this.closeTimeout = setTimeout(() => {
      this.classList.remove('tooltip--visible');
    }, this.settings.timeout || 2000);
  }

  // Reset other visible tooltips except the current one
  _resetTooltips(excludeTooltip = null) {
    document.querySelectorAll('.tooltip--visible').forEach((tooltip) => {
      if (tooltip !== excludeTooltip) {
        tooltip.classList.remove('tooltip--visible');
      }
    });
  }
}

// Register the custom element
if (!customElements.get('cos-tooltip')) customElements.define('cos-tooltip', CosTooltip);

// Export for module usage
export { CosTooltip };
